module.exports = __webpack_public_path__ + "static/media/Food2.5d911fb1.png";